exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body .ui-datatable .ui-datatable-thead > tr > th,\r\nbody .ui-datatable .ui-datatable-tfoot > tr > td {\r\n    padding: 0.5em;\r\n}\r\n\r\nbody .ui-datatable .ui-datatable-data > tr > td {\r\n    padding: .5em;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/gas/gas-dashboard/gas-dashboard.component.css
// module id = 697
// module chunks = 0